import styled from 'styled-components'

export const Header = styled.header`
  background-color: #fff;
  border-bottom: 4px solid var(--theme-primary);
  display: grid;
  grid-template-columns: 300px 1fr 320px;
  height: 80px;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: var(--z-index-header);
`

export const Logo = styled.div`
  align-items: center;
  display: flex;
  padding: 0 0 0 80px;

  > img {
    cursor: pointer;
    height: 35px;
  }
`

export const Middle = styled.div`
  align-items: center;
  display: flex;
  padding: 0 0 0 40px;
`

export const Login = styled.div`
  align-items: center;
  display: flex;
  justify-content: end;
  gap: 16px;
  padding: 0 40px 0 0;
`
